import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { getMessagemErro } from "../../utils/erro";
import api from "../../services/api";
import './SolicitacaoAdesaoArquivosGrandesVoumes.css';

import { SolicitacaoAdesaoArquivosGrandesVolumesDetails } from "./Details";
import { SolicitacaoAdesaoAttachmentsAndHistory } from "./AttachmentsAndHistory";
import { SecureDirectoryConfiguration } from "../SecureDirectory/SecureDirectoryConfiguration";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

export const SolicitacaoAdesaoArquivosGrandesVolumesSecureDirectory =

withRouter(

// redux
connect(
	(null), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				solicitacao: {
					numero: '',
					nomeSituacao: '',
					orgao: '',
					tituloConjuntoArquivo: '',
					nomeOrgaoConjuntoArquivo: '',
					descricaoConjuntoArquivo: '',
					arquivos: [],
					nomeDirigenteTi: '',
					nomeResponsavelTecnico: '',
					finalidade: '',
					nomePastaSegura: '',
					andamentoImplantacao: '',
					dataConclusaoImplantacao: '',
				},
				botoesHabilitados: true,
				keySecureDirectory: new Date(),
			};
			this.onChangeProperties = this.onChangeProperties.bind(this);
			this.alterarAndamentoConfiguracaoPastaSegura = this.alterarAndamentoConfiguracaoPastaSegura.bind(this);
			this.concluirConfiguracaoPastaSeguraSolicitacao = this.concluirConfiguracaoPastaSeguraSolicitacao.bind(this);
			this.atualizaConfiguracaoPastaSegura = this.atualizaConfiguracaoPastaSegura.bind(this);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;

			api.get(`/api/solicitacao-adesao-arquivo-gv/${id}`)
				.then(response => { 
					const solicitacao = response.data;
					this.setState({ solicitacao }) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar a solicitação de adesão a arquivos de grandes volumes.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				});
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Solicitação de Adesão a Arquivos de Grandes Volumes</h1>
					</div>
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		renderForm() {
			const { solicitacao , botoesHabilitados, keySecureDirectory } = this.state;

			return(
				<div className="container-fluid">

						<SolicitacaoAdesaoArquivosGrandesVolumesDetails solicitacao={solicitacao} mostraDetalhesAprovacao={false}/>

						<SecureDirectoryConfiguration solicitacao={solicitacao} botoesHabilitados={botoesHabilitados} 
							onChangeProperties={this.onChangeProperties}
							alterarAndamentoConfiguracaoPastaSegura={this.alterarAndamentoConfiguracaoPastaSegura}
							concluirConfiguracaoPastaSeguraSolicitacao={this.concluirConfiguracaoPastaSeguraSolicitacao}
							keySecureDirectory={keySecureDirectory}
						/>
						
						<SolicitacaoAdesaoAttachmentsAndHistory solicitacao={solicitacao} habilitaEdicaoAnexo={true}/>
				</div>

			);
		}

		onChangeProperties(nome, valor){
			const solicitacao = this.state.solicitacao;
			solicitacao[nome] = valor;
			this.setState({ solicitacao, keySecureDirectory: new Date() });
		}

		alterarAndamentoConfiguracaoPastaSegura() {
			const mensagemSucesso = "Pasta Segura alterada com sucesso.";
			const mensagemErro = "Não foi possível alterar a Pasta Segura.";
			const url = '/api/solicitacao-adesao-arquivo-gv/configurar-pasta-segura';
			this.atualizaConfiguracaoPastaSegura(url, false, mensagemSucesso, mensagemErro);
		}

		concluirConfiguracaoPastaSeguraSolicitacao() {
			const mensagemSucesso = "Pasta Segura configurada com sucesso.";
			const mensagemErro = "Não foi possível concluir a pasta segura.";
			const url = '/api/solicitacao-adesao-arquivo-gv/configurar-pasta-segura';
			this.atualizaConfiguracaoPastaSegura(url, true, mensagemSucesso, mensagemErro);
		}

		atualizaConfiguracaoPastaSegura (url, concluido, mensagemSucesso, mensagemErro) {
			const { solicitacao } = this.state;

			if (concluido) {
				solicitacao.implantacaoConcluida = true;
			} else {
				solicitacao.implantacaoConcluida = false;
			}
			
			const options = {
				method: 'put',
				url,
				data: { ...solicitacao },
			}

			this.props.limpaMensagem();
			this.props.mostraAguardando();
			window.scrollTo(0, 0);
			api(options)
				.then(response => { 
					this.setState({
						solicitacao: response.data,
					}) 
					this.props.exibeMensagemSucesso(mensagemSucesso);
				})
				.catch(erro => {
					const msg = getMessagemErro(mensagemErro, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
					 setTimeout(() => {
						window.scrollTo(0, 0);
					}, 100); 
					
				});
		}
		
	}

) // redux
); // router